/*
 * @Author: mayanxia 
 * @Date: 2020-10-20 08:43:26 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-05 14:20:30
 */

let BASE_URL = ''

if (process.env.NODE_ENV == 'development') {
	// BASE_URL = 'http://127.0.0.1:8009/part-util' // 开发环境
	// BASE_URL = 'http://172.16.8.163:8008/part-util' // 开发环境
	// BASE_URL = 'http://172.16.8.162:9999' // 开发环境-微服务hf
	// BASE_URL = 'http://192.168.137.1:9999' // 开发环境-微服务hf
  	//BASE_URL = 'http://120.70.101.150:9999' //微服务正式地址
  	// BASE_URL = 'http://220.154.8.216:9000/api'
	// BASE_URL = 'http://120.71.183.37:9999' //额敏测试地址
  BASE_URL = 'http://172.16.8.31:9999' //开发本地
	// BASE_URL = 'http://172.16.8.132:9999' // 开发环境wjt
	// BASE_URL = 'http://120.70.101.150:8008/part-util' //正式地址
	//BASE_URL = 'http://wechatinterface.iotsmartmeter.cn:8008/part-util'
	//BASE_URL = 'http://1.15.151.178:8008/part-util'//和静县地址
//   BASE_URL = 'http://172.16.8.30:9999' //开发本地
//   BASE_URL = 'http://172.16.8.30:9999' //开发本地
//   BASE_URL = 'http://172.16.8.202:9999' //开发本地
//   BASE_URL = 'http://172.16.8.132:9999' //开发本地
// BASE_URL = 'http://120.71.183.37:9999' //开发测试
//   BASE_URL = 'http://172.16.8.34:9999' //开发本地

} else {
	// BASE_URL = 'https://eminwechat.xjzdcsyyyxzrgs.com/api' //额敏正式域名地址
	BASE_URL = 'https://emincloud.xjzdcsyyyxzrgs.com/api' //额敏测试域名地址
	// BASE_URL = 'http://120.70.101.150:3003/api' //额敏正式地址
	// BASE_URL = 'http://120.71.183.37:3003/api' //额敏测试地址
}

const configService = {
	apiUrl: BASE_URL,
	backType: 2 // 连接后后台的类型，用这个来控制大屏和一张图中地图显示为望都县还是商洛市的；1为商洛市，2为望都县 3为巴音郭楞蒙古自治州和静县
};

export default configService